import React from 'react'
import { Box, Stack, Text, TextLink } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import useSearchParams from '@/hooks/use-search-params'
import EmptyImage from '../images/empty-auto-reply-message-image'
import { EmptyMessageStyle } from '../index.css'

const AutoReplyEmptyComponent: React.FC = () => {
  const { t } = useTranslation()
  const { trigger = 'first_tenant_message_received' }: { trigger?: string } = useSearchParams()

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      className={EmptyMessageStyle}
    >
      <Box>
        <Stack align="center" space="large">
          <EmptyImage />
          <Stack align="center" space="medium">
            <Text size="standard" weight="medium">
              {t('l.settings.view.auto_reply.no_auto_reply', 'You don’t have any auto-replies yet')}
            </Text>
            <Box style={{ width: '250px' }} maxWidth="small">
              <Text size="small" weight="regular" align={'center'}>
                {t(
                  'l.settings.view.auto_reply.create_auto_reply',
                  'Create automated messages to save time replying to applicants.'
                )}
              </Text>
            </Box>
            <TextLink href={`/settings/auto-reply/auto-reply-message/create?trigger=${trigger}`}>
              <Text tone="link" size="small">
                {t('l.settings.view.auto_reply.add_auto_reply', 'Add Auto Reply')}
              </Text>
            </TextLink>
          </Stack>
        </Stack>
      </Box>
    </Box>
  )
}

export default AutoReplyEmptyComponent
